import { render, staticRenderFns } from "./FamilyOrderList.vue?vue&type=template&id=1d12a4a2&scoped=true"
import script from "./FamilyOrderList.vue?vue&type=script&lang=js"
export * from "./FamilyOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12a4a2",
  null
  
)

export default component.exports